import { Article } from '../../types'

export const MOCK_HEALTH_ARTICLES: Article[] = [
  {
    source: {
      name: 'KSL.com',
    },
    title:
      "Family fundraising to save toddler with disorder that turns babies into 'human time bombs' - KSL.com",
    author: 'https://www.facebook.com/kslcom/',
    url: 'https://www.ksl.com/article/50598831/family-fundraising-to-save-toddler-with-disorder-that-turns-babies-into-human-time-bombs',
    urlToImage:
      'https://img.ksl.com/slc/2920/292009/29200931.jpeg?filter=kslv2/responsive_story_lg',
    publishedAt: '2023-03-14T04:08:52Z',
  },
  {
    source: {
      name: 'Foreign Affairs',
    },
    title: 'How to Handle the Bird Flu - Foreign Affairs Magazine',
    author: 'Caitlin Rivers',
    url: 'https://www.foreignaffairs.com/united-states/next-pandemic-bird-flu-preparedness',
    urlToImage:
      'https://cdn-live.foreignaffairs.com/sites/default/files/styles/social_share/public/images/2023/03/13/RTSB0Z6E.jpg?itok=JN5bXv0_',
    publishedAt: '2023-03-14T04:00:00Z',
  },
  {
    source: {
      name: 'New York Post',
    },
    title:
      'Scientists revive ‘zombie viruses’ from permafrost that can infect cells - New York Post ',
    author: 'Fox News',
    url: 'https://nypost.com/2023/03/13/scientists-revive-zombie-viruses-from-permafrost-that-can-infect-cells/',
    urlToImage:
      'https://nypost.com/wp-content/uploads/sites/2/2023/03/NYPICHPDPICT000008220032.jpg?quality=75&strip=all&w=1024',
    publishedAt: '2023-03-14T02:42:00Z',
  },
  {
    source: {
      name: 'BBC News',
    },
    title: 'The mystery of Alice in Wonderland syndrome - BBC',
    author: 'Roberta Angheleanu',
    url: 'https://www.bbc.com/future/article/20230313-the-mystery-of-alice-in-wonderland-syndrome',
    urlToImage: 'https://ychef.files.bbci.co.uk/live/624x351/p0f8jbdw.jpg',
    publishedAt: '2023-03-14T01:03:33Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: 'Mediterranean diet linked with reduced risk of dementia - CNN',
    author: 'Katie Hunt',
    url: 'https://www.cnn.com/2023/03/13/health/mediterranean-diet-dementia-wellness/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313160629-mediterranean-diet-dementia.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T01:00:00Z',
  },
  {
    source: {
      name: 'Boropark24.com',
    },
    title:
      'AD: He Used to Bring Joy to the Bedridden, Now he Has Stage 4 Brain Cancer – Boro Park 24 - Boro Park 24',
    author: null,
    url: 'https://www.boropark24.com/news/ad-he-used-to-bring-joy-to-the-bedridden-now-he-has-stage-4-brain-cancer',
    urlToImage:
      'https://mcmdx84dte.execute-api.us-east-1.amazonaws.com/production/news/35764034-1678752507640fbaf8b71f316787525047501.jpeg?width=300&height=300',
    publishedAt: '2023-03-14T00:08:42Z',
  },
  {
    source: {
      name: 'New York Post',
    },
    title:
      'Height, status-obsessed parents rush to inject kids with growth hormones - New York Post ',
    author: 'Jeanette Settembre',
    url: 'https://nypost.com/2023/03/13/parents-say-growth-hormone-boosts-kids-chance-of-success/',
    urlToImage:
      'https://nypost.com/wp-content/uploads/sites/2/2023/03/hormone-growth-kids.jpeg?quality=75&strip=all&w=1024',
    publishedAt: '2023-03-14T00:07:00Z',
  },
  {
    source: {
      name: 'Unsw.edu.au',
    },
    title:
      'Exposing tumours to bacteria converts immune cells to cancer killers - UNSW Newsroom',
    author: 'z3539585',
    url: 'https://newsroom.unsw.edu.au/news/science-tech/exposing-tumours-bacteria-converts-immune-cells-cancer-killers',
    urlToImage:
      'https://newsroom.unsw.edu.au/sites/default/files/thumbnails/image/microbial_therapy_feature_image_2.jpg',
    publishedAt: '2023-03-13T21:31:00Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title: 'Mental Fatigue Can Impair Physical Performance - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/mental-fatigue-exercise-22780/',
    urlToImage: null,
    publishedAt: '2023-03-13T21:00:05Z',
  },
  {
    source: {
      name: 'Live Science',
    },
    title:
      "Roman-era tomb scattered with magical 'dead nails' and sealed off to shield the living from the 'restless dead' - Livescience.com",
    author: 'Kristina Killgrove',
    url: 'https://www.livescience.com/roman-era-tomb-scattered-with-magical-dead-nails-and-sealed-off-to-shield-the-living-from-the-restless-dead',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/oPyZRtQbym7b3zaPbx6F65-1200-80.jpg',
    publishedAt: '2023-03-13T20:43:16Z',
  },
  {
    source: {
      name: 'Gizmodo.com',
    },
    title:
      "A Bad Night's Sleep Could Weaken Your Response to Vaccines - Gizmodo",
    author: 'Ed Cara',
    url: 'https://gizmodo.com/getting-enough-sleep-affects-vaccine-immune-response-1850220913',
    urlToImage:
      'https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/cac4de870b36c022235d6830f01ec080.jpg',
    publishedAt: '2023-03-13T20:33:00Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title:
      'Calcium: A Key Player for a Promising and Safe Brain Treatment? - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/calcium-brain-treatment-22777/',
    urlToImage: null,
    publishedAt: '2023-03-13T19:58:46Z',
  },
  {
    source: {
      name: 'WWBT NBC12 News',
    },
    title: '‘Ozempic face’: Richmond doctor separates fact from fiction - WWBT',
    author: null,
    url: 'https://www.nbc12.com/2023/03/13/ozempic-face-richmond-doctor-separates-fact-fiction/',
    urlToImage:
      'https://gray-wwbt-prod.cdn.arcpublishing.com/resizer/TD61KtTRyqxVas2hs5bbfrz5Yec=/1200x600/smart/filters:quality(85)/cloudfront-us-east-1.images.arcpublishing.com/gray/BRDREHKYOJCTDP2JC6GVRT4UQA.png',
    publishedAt: '2023-03-13T19:55:00Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title:
      'Epilepsy Could Become Easier to Pinpoint With Blood Test - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/epilepsy-blood-test-22776/',
    urlToImage:
      'https://neurosciencenews.com/files/2023/03/epilepsy-blood-test-neurosicences-public-1.jpg',
    publishedAt: '2023-03-13T19:37:38Z',
  },
  {
    source: {
      name: 'Live Science',
    },
    title:
      'Prostate cancer treatments can be avoided or delayed in many cases, huge study finds - Livescience.com',
    author: 'Nicoletta Lanese',
    url: 'https://www.livescience.com/prostate-cancer-treatments-can-be-avoided-or-delayed-in-many-cases-huge-study-finds',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/bNoH3WghRfxyau9dvrC4ai-1200-80.jpg',
    publishedAt: '2023-03-13T19:27:24Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title:
      'Diabetes and Toothlessness Together Worsen Cognitive Decline - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/diabetes-oral-health-cognition-22774/',
    urlToImage: null,
    publishedAt: '2023-03-13T18:40:15Z',
  },
  {
    source: {
      name: 'Newsmax',
    },
    title: 'A-Fib May Increase Risk for Dementia - Newsmax',
    author: '',
    url: 'https://www.newsmax.com/health/health-news/atrial-fibrillation-a-fib-dementia/2023/03/13/id/1112012/',
    urlToImage:
      'https://www.newsmax.com/CMSPages/GetFile.aspx?guid=d788e9ef-6952-491b-97f6-595039d399d8&SiteName=Newsmax',
    publishedAt: '2023-03-13T18:35:00Z',
  },
  {
    source: {
      name: 'LGBTQ Nation',
    },
    title:
      'Marjorie Taylor Greene is selling t-shirts making fun of people with mpox - msnNOW',
    author: null,
    url: 'https://www.lgbtqnation.com/2023/03/majorie-taylor-greene-is-selling-t-shirts-making-fun-of-people-with-mpox/',
    urlToImage:
      'https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AAZZEku.img?h=315&w=600&m=6&q=60&o=t&l=f&f=jpg&x=536&y=244',
    publishedAt: '2023-03-13T18:30:39Z',
  },
  {
    source: {
      name: 'Newsmax',
    },
    title: 'Eat These Foods to Boost Your Mood and Energy - Newsmax',
    author: 'Newsmax',
    url: 'https://www.newsmax.com/health/health-news/food-mood-energy/2023/03/13/id/1112062/',
    urlToImage: null,
    publishedAt: '2023-03-13T18:01:14Z',
  },
  {
    source: {
      name: 'National Institutes of Health',
    },
    title:
      'Scientists reveal a potential new approach to treating liver cancer - National Institutes of Health (.gov)',
    author: null,
    url: 'https://www.nih.gov/news-events/news-releases/scientists-reveal-potential-new-approach-treating-liver-cancer',
    urlToImage:
      'https://www.nih.gov/sites/default/files/news-events/news-releases/2023/20230313-liver.jpg',
    publishedAt: '2023-03-13T17:57:45Z',
  },
  {
    source: {
      name: 'Eatingwell.com',
    },
    title:
      "4 Supplements You Shouldn't Be Taking If You Have High Cholesterol, According to a Dietitian - EatingWell",
    author: 'Barbie Cervoni MS, RD, CDCES, CDN',
    url: 'https://www.eatingwell.com/article/8030938/supplements-you-shouldnt-be-taking-if-you-have-high-cholesterol/',
    urlToImage:
      'https://imagesvc.meredithcorp.io/v3/mm/image?q=60&c=sc&poi=%5B1000%2C573%5D&w=2000&h=1000&url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F44%2F2023%2F03%2F13%2F4-Supplements-You-Shouldnt-Be-Taking-if-You-Have-High-Cholesterol-According-to-a-Dietitian.jpg',
    publishedAt: '2023-03-13T17:52:37Z',
  },
  {
    source: {
      name: 'PsyPost',
    },
    title:
      'Study finds exposure to diesel exhaust can impair brain functioning in a matter of hours - PsyPost',
    author: 'Laura Staloch',
    url: 'https://www.psypost.org/2023/03/study-finds-exposure-to-diesel-exhaust-can-impair-brain-functioning-in-a-matter-of-hours-69574',
    urlToImage:
      'https://www.psypost.org/wp-content/uploads/2023/03/traffic-diesel-exhaust-pollution.jpg',
    publishedAt: '2023-03-13T17:34:10Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title: 'A New Immune Pathway Sheds Light on ALS - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/als-immune-pathway-22769/',
    urlToImage:
      'https://neurosciencenews.com/files/2023/03/als-immune-pathway-neuroscience-public-1-1.jpg',
    publishedAt: '2023-03-13T17:30:39Z',
  },
  {
    source: {
      name: 'Nature.com',
    },
    title:
      'The genetic basis of endometriosis and comorbidity with other pain and inflammatory conditions - Nature.com',
    author: null,
    url: 'https://www.nature.com/articles/s41588-023-01323-z',
    urlToImage:
      'https://media.springernature.com/m685/springer-static/image/art%3A10.1038%2Fs41588-023-01323-z/MediaObjects/41588_2023_1323_Fig1_HTML.png',
    publishedAt: '2023-03-13T16:49:04Z',
  },
  {
    source: {
      name: 'Neurosciencenews.com',
    },
    title:
      'Novel Genes That May Increase Risk for Schizophrenia Identified - Neuroscience News',
    author: 'Neuroscience News',
    url: 'https://neurosciencenews.com/new-schizophrenia-genes-22767/',
    urlToImage:
      'https://neurosciencenews.com/files/2023/03/novel-schizophrenia-genes-neurosicnes-public-1.jpg',
    publishedAt: '2023-03-13T16:46:54Z',
  },
]
